import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { request } from '../service/common';
import { concat } from 'lodash';

const ITEM_PERPAGE = 10;
interface ProjectState {
    projectList: any[],
    roles: any[],
    selectedProject: any,
    loadingProject: Boolean,
    totalCount: Number
}

let initialState: ProjectState = {
    projectList: [],
    roles:[],
    selectedProject: {},
    loadingProject: false,
    totalCount: 0
}

const getProjectList: any = createAsyncThunk(
    'getProjectList',
    async (data: any, { rejectWithValue }) => {
        try {
            const { search, page, limit } = data;
            let requestApiUrl = `/project/list?search=${search}&limit=${limit}&page=${page}`;
            const response: any = await request('get', requestApiUrl);
            return { data: response.data.data, total: response.data.total };
        } catch (err) {
            console.log("err", err)
            return rejectWithValue(err)
        }
    }
);


const getProjectById: any = createAsyncThunk(
    'getProjectById',
    async (id, { rejectWithValue }) => {
        try {
            let requestApiUrl = '/project/project/' + id;
            const response: any = await request('get', requestApiUrl);
            return { data: response.data.data };
        } catch (err) {
            console.log("err", err)
            return rejectWithValue(err)
        }
    }
);

const addAction: any = createAsyncThunk(
    'addAction',
    async (datas: any, { rejectWithValue }) => {
        try {
            const { id, data } = datas
            console.log("data",data)
            let requestApiUrl = '/project/add-action/' + id;
            const response: any = await request('put', requestApiUrl,data);
            return { data: response.data.data };
        } catch (err) {
            console.log("err", err)
            return rejectWithValue(err)
        }
    }
);
const editAction: any = createAsyncThunk(
    'editAction',
    async (datas: any, { rejectWithValue }) => {
        console.log("data",datas)

        try {
            const { project_id,action_id, data } = datas
            let requestApiUrl = `/project/edit-action/${project_id}/action/${action_id}`;
            const response: any = await request('put', requestApiUrl,data);
            return { data: response.data.data };
        } catch (err) {
            console.log("err", err)
            return rejectWithValue(err)
        }
    }
);
const addProject: any = createAsyncThunk(
    'addProject',
    async (data: any, { rejectWithValue }) => {
        try {
            let requestApiUrl = '/project/create' ;
            const response: any = await request('post', requestApiUrl,data);
            return { data: response.data.data };
        } catch (err) {
            console.log("err", err)
            return rejectWithValue(err)
        }
    }
);
const editProject: any = createAsyncThunk(
    'editProject',
    async (datas: any, { rejectWithValue }) => {
        console.log("data",datas)

        try {
            const { project_id, data } = datas
            let requestApiUrl = `/project/update/${project_id}`;
            const response: any = await request('put', requestApiUrl,data);
            return { data: response.data.data };
        } catch (err) {
            console.log("err", err)
            return rejectWithValue(err)
        }
    }
);
const deleteAction: any = createAsyncThunk(
    'deleteAction',
    async (datas: any, { rejectWithValue }) => {
        console.log("data",datas)

        try {
            const { project_id,action_id, data } = datas
            let requestApiUrl = `/project/delete-action/${project_id}/action/${action_id}`;
            const response: any = await request('delete', requestApiUrl);
            return { data: response.data.data };
        } catch (err) {
            console.log("err", err)
            return rejectWithValue(err)
        }
    }
);
const addRoles: any = createAsyncThunk(
    'addRoles',
    async (datas: any, { rejectWithValue }) => {
        console.log("data",datas)

        try {
            const { project_id,data } = datas
            let requestApiUrl = `/project/update-role/${project_id}`;
            const response: any = await request('put', requestApiUrl,data);
            return { data: response.data.data };
        } catch (err) {
            console.log("err", err)
            return rejectWithValue(err)
        }
    }
);
const slice = createSlice({
    name: 'project',
    initialState,
    reducers: {
      
    },
    extraReducers: {
        // Add reducers for additional action types here, and handle loadingNotice state as needed
        [getProjectList.fulfilled]: (state, action) => {
            const { data, total } = action.payload;
            state.totalCount = total
            state.projectList = data;
        },
        [getProjectList.pending]: (state, action) => {
        },
        [getProjectList.rejected]: (state, action) => {

        },
        [getProjectById.fulfilled]: (state, action) => {
            console.log(action.payload)
            const { data } = action.payload;
            state.selectedProject = data
            state.roles = data.roles

            state.loadingProject = false;
        },
        [getProjectById.pending]: (state, action) => {
            state.selectedProject = {}
            state.loadingProject = true;
        },
        [getProjectById.rejected]: (state, action) => {
            state.loadingProject = false;

        },
        [addAction.fulfilled]: (state, action) => {
            console.log("action.payload",action.payload)
            const { data } = action.payload;
            state.selectedProject = data
            // state.loadingProject = false;
        },
        [addAction.pending]: (state, action) => {
            // state.selectedProject = {}
            state.loadingProject = true;
        },
        [addAction.rejected]: (state, action) => {
            state.loadingProject = false;

        },
        [editAction.fulfilled]: (state, action) => {
            const { data } = action.payload;
            state.selectedProject = data
            state.loadingProject = false;
        },
        [editAction.pending]: (state, action) => {
            // state.selectedProject = {}
            state.loadingProject = true;
        },
        [editAction.rejected]: (state, action) => {
            state.loadingProject = false;

        },
        [deleteAction.fulfilled]: (state, action) => {
            const { data } = action.payload;
            state.selectedProject = data
            state.loadingProject = false;
        },
        [deleteAction.pending]: (state, action) => {
            // state.selectedProject = {}
            state.loadingProject = true;
        },
        [deleteAction.rejected]: (state, action) => {
            state.loadingProject = false;

        },
        [addProject.fulfilled]: (state, action) => {
            const { data } = action.payload;
            state.selectedProject = data
            state.loadingProject = false;
        },
        [addProject.pending]: (state, action) => {
            // state.selectedProject = {}
            state.loadingProject = true;
        },
        [addProject.rejected]: (state, action) => {
            state.loadingProject = false;

        },
        [editProject.fulfilled]: (state, action) => {
            const { data } = action.payload;
            state.selectedProject = data
            state.loadingProject = false;
        },
        [editProject.pending]: (state, action) => {
            // state.selectedProject = {}
            state.loadingProject = true;
        },
        [editProject.rejected]: (state, action) => {
            state.loadingProject = false;

        },
        [addRoles.fulfilled]: (state, action) => {
            const { data } = action.payload;
            
            state.selectedProject = data;
            state.roles = data.roles

            state.loadingProject = false;
        },
        [addRoles.pending]: (state, action) => {
            // state.selectedProject = {}
            state.loadingProject = true;
        },
        [addRoles.rejected]: (state, action) => {
            state.loadingProject = false;

        }
    }
})




// export const { setNotice} = slice.actions;
export { getProjectList, getProjectById,addAction,editAction,deleteAction,editProject,addProject,addRoles };
export default slice.reducer;